import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Euro, BarChart3, Gauge, GitCompareArrows } from 'lucide-react';

const TABS = [
  // El resumen va primero: es la foto general de la que cuelgan las otras dos,
  // el ranking por propiedad y la comparación entre periodos.
  {
    to: '/finance',
    label: 'Resumen',
    icon: BarChart3,
    end: true,
    desc: 'Lo que factura Sereno y el volumen y rendimiento de todas las reservas',
  },
  {
    to: '/finance/performance',
    label: 'Performance',
    icon: Gauge,
    end: false,
    desc: 'Ranking por propiedad o por propietario: facturación, neto y ganancia estimada para Sereno y propietarios',
  },
  {
    to: '/finance/comparativas',
    label: 'Comparativas',
    icon: GitCompareArrows,
    end: false,
    desc: 'Compara KPIs y facturación entre dos periodos',
  },
];

/**
 * Agrupa en una sola entrada del menú las tres vistas financieras de Analytics
 * —Resumen, Performance y Comparativas—, que antes colgaban sueltas del
 * sidebar. Cada pestaña conserva su ruta para que siga siendo enlazable y el
 * botón de atrás del navegador se comporte.
 *
 * A diferencia de Aperturas y Llamadas, aquí el layout no comparte periodo por
 * el outlet: cada vista pregunta cosas distintas (un rango, un ranking, dos
 * rangos que comparar) y ya trae sus propios filtros.
 */
export default function FinanceLayout() {
  const { pathname } = useLocation();
  const activa = TABS.find(t => (t.end ? pathname === t.to : pathname.startsWith(t.to))) ?? TABS[0];

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-sereno-blue/50 text-sereno-dark">
          <Euro size={22} />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Finance</h1>
          {/* El subtítulo es el de la pestaña abierta: el título agrupa, pero lo
              que se está mirando sigue explicándose solo. */}
          <p className="text-sm text-sereno-dark/50">{activa.desc}</p>
        </div>
      </div>

      <div className="border-b border-slate-200 dark:border-white/10 mb-6">
        <nav className="flex gap-1 -mb-px overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 scrollbar-none">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 sm:px-4 py-3 sm:py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                  isActive
                    ? 'border-sereno-dark text-sereno-dark font-medium dark:border-white dark:text-white'
                    : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
